exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_IwO i{font-size:25px;margin:0 15px;cursor:pointer}._1xnT8{display:none}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:#fff}::-webkit-scrollbar-thumb,::-webkit-scrollbar-thumb:hover{background:#e4002b}h3{color:#000!important}", ""]);

// exports
exports.locals = {
	"footerContent": "_2_IwO",
	"fileUpload": "_1xnT8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalVideoLlamada/FooterModalVideoLlamada/FooterModalVideoLlamada.css
// module id = 1158
// module chunks = 0 1 2